export const DD_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN!;
export const DD_APPLICATION_ID = process.env.NEXT_PUBLIC_DD_APPLICATION_ID!;
export const DD_ENV_NAME = process.env.NEXT_PUBLIC_DD_ENV_NAME!;
export const DD_SERVICE_NAME = process.env.NEXT_PUBLIC_DD_SERVICE_NAME!;
export const DD_SITE_URL = process.env.NEXT_PUBLIC_DD_SITE_URL!;
export const DD_RUM_VERSION = process.env.NEXT_PUBLIC_DD_RUM_VERSION!;
export const DD_SESSION_REPLAY_SAMPLE_RATE =
  process.env.NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE!;
